/**
 * The one type spec every green CTA on this LP renders with, taken from the source design's
 * `.cta { font: 750 14px/1 var(--body) }`.
 *
 * It has to be declared inline rather than left to Tailwind classes. `public/css/trial-beta.css`
 * carries `.trial-beta-page button { font: inherit }` — a `font` shorthand, so it resets family,
 * size AND weight — and at specificity 0,1,1 it beats `.text-sm` / `.font-bold` at 0,1,0. A button
 * styled with those classes therefore renders at the page's inherited 16px/400, which is how the
 * hero's signup CTA ended up as a fourth font variant (SCRUM-1886) while still *looking* styled
 * in the markup.
 *
 * The two CTAs defined purely in CSS (Multiconnection's `.cta`, and `.np-final-action button`,
 * which is deliberately larger at 800/17px as the closing call) declare the same values in the
 * stylesheet and need nothing from here.
 */
export const CTA_FONT = { fontFamily: 'var(--font-outfit)', fontWeight: 750, fontSize: '14px' } as const;
